import { PostCell } from './Cells'
import { MarkAsNotSpam, PermanentlyDelete } from './BulkActions'
import { createAuthorColumn } from './Columns'
import { getSpamContent } from './service'
/* eslint-disable import/no-internal-modules */
import Overview from '@insided/deprecated-control/overview'
import EmptyPage from '@insided/deprecated-preact-components/empty-page/EmptyPage'
import globals from '@insided/deprecated-utils/globals'
import DateCell from '@insided/deprecated-control/overview/cells/DateCell'

const SpamOverview = () => {
  function getColumns() {
    return [
      {
        header: 'Post',
        size: 'xl',
        cell: (props: any) => <PostCell {...props} />
      },
      {
        header: 'Published in',
        cell: ({ category }: { category: { name: string } }) => category?.name
      },
      createAuthorColumn(),
      { header: 'Publish date', cell: DateCell('createdAt') }
    ]
  }

  function getBulkActions() {
    return [MarkAsNotSpam, PermanentlyDelete]
  }

  return (
    <Overview
      type='spam'
      headerTitle='Spam'
      withPagination={{
        page: 1,
        pageSize: 25
      }}
      rowId='key'
      model={getColumns()}
      dataSource={getSpamContent}
      entity='posts'
      bulkActions={getBulkActions()}
      EmptyStateComponent={
        <EmptyPage
          img_src={`${globals('basePath')}images/empty_spam.png`}
          header='All good!'
          text='Nice and clean, there is no spam.'
          button={{ link: '/overview', text: 'Go back to overview' }}
        />
      }
    />
  )
}

export default SpamOverview
